<div class="wrapper">
    <app-header></app-header>
    <div class="main-page pt-4">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>